import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield, Users, AlertTriangle, Eye, Lock, MessageSquare, ShoppingCart, MessageCircle } from 'lucide-react';

export const CommunityGuidelines = () => {
  const guidelines = [
    {
      icon: <Users className="w-6 h-6 text-green-600" />,
      title: "Respect each other",
      description: "Farmers face enough challenges — let's not add to them here."
    },
    {
      icon: <Eye className="w-6 h-6 text-blue-600" />,
      title: "Share honestly",
      description: "Photos, updates, and experiences should be your own."
    },
    {
      icon: <MessageCircle className="w-6 h-6 text-indigo-600" />,
      title: "Keep private content private",
      description: "We do not recommend posting private content. Communicate in private messages between people rather than posting publicly."
    },
    {
      icon: <AlertTriangle className="w-6 h-6 text-red-600" />,
      title: "No scams",
      description: "No false prices, fake loans, or misleading financing offers."
    },
    {
      icon: <ShoppingCart className="w-6 h-6 text-orange-600" />,
      title: "No marketing or sales",
      description: "No advertising, sales, or marketing. If interested in selling or advertising, contact welcome.yieldsocial@yieldbase.ai"
    },
    {
      icon: <MessageSquare className="w-6 h-6 text-amber-600" />,
      title: "Stay on topic",
      description: "Farming, food systems, financing, and community are welcome. Politics only if it directly affects farming."
    },
    {
      icon: <Lock className="w-6 h-6 text-purple-600" />,
      title: "Protect privacy",
      description: "Don't share others' info without permission."
    }
  ];

  return (
    <div className="p-4 max-w-2xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-white mb-2 flex items-center gap-2">
          <Shield className="w-7 h-7 text-white" />
          YieldSocial Community Guidelines
        </h1>
        <p className="text-white/90">
          Building a supportive farming community together
        </p>
      </div>

      <div className="space-y-4 mb-8">
        {guidelines.map((guideline, index) => (
          <Card key={index} className="border-l-4 border-l-green-500">
            <CardContent className="p-4">
              <div className="flex items-start gap-3">
                {guideline.icon}
                <div>
                  <h3 className="font-semibold text-foreground mb-1">
                    {guideline.title}
                  </h3>
                  <p className="text-muted-foreground text-sm">
                    {guideline.description}
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card className="border-red-200 bg-red-50/50">
        <CardHeader>
          <CardTitle className="text-red-700 flex items-center gap-2">
            <AlertTriangle className="w-5 h-5" />
            Enforcement Policy
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-red-800 text-sm font-medium">
            Any user who is flagged for violating these community guidelines will be permanently removed from the YieldSocial community. We maintain a zero-tolerance policy to ensure a safe and supportive environment for all farmers.
          </p>
        </CardContent>
      </Card>

      <div className="mt-6 p-4 bg-green-50/50 rounded-lg border border-green-200">
        <p className="text-green-800 text-sm">
          <strong>Remember:</strong> YieldSocial is built for farmers. Let's work together to maintain a community that supports everyone's success.
        </p>
      </div>
    </div>
  );
};